export default {
  welcomeLogin: "welcome login",
};
